import { useColorMode } from '@chakra-ui/react';
import Anonymous from '../../../icons/Anonymous';
import ExchangeHorizontal from '../../../icons/ExchangeHorizontal';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';

interface ChatInputProfileItemProps {
  isAnonymous: boolean;
  thumbnailUrl: string;
  onClick?: () => void;
}

const ChatInputProfileItem = ({
  isAnonymous,
  thumbnailUrl,
  onClick
}: ChatInputProfileItemProps) => {
  const { colorMode } = useColorMode();
  return (
    <button
      type="button"
      onClick={onClick}
      className="p-[6px] relative flex items-center justify-center"
    >
      {isAnonymous ? (
        <Anonymous currentColor="#5C3DFA" />
      ) : (
        <ProfileAvatar thumbnailUrl={thumbnailUrl} />
      )}
      <div className="absolute bottom-[2px] right-[2px]  bg-primary-light dark:bg-primary-dark rounded-full p-[1px] border-[2px] border-[#F5F3FF] dark:border-[#2C2A46]">
        <ExchangeHorizontal size={9} currentColor={colorMode === 'dark' ? '#2C2A46' : '#FFFFFF'} />
      </div>
    </button>
  );
};

export default ChatInputProfileItem;
